import React from 'react';
import LineChart from '../../../components/charts/LineChart';
import BarChart from '../../../components/charts/BarChart';

// T6.9: consumes ONLY components/charts primitives — no direct echarts
// imports in features/ (T5 done_when contract).
function PerformanceChart({ performance }) {
  if (!performance) {
    return <p className="tab-empty">Performance data unavailable.</p>;
  }

  const { labels, successRate, cost } = performance;

  return (
    <div className="performance-charts">
      <section className="chart-card">
        <header className="chart-card-heading">
          <h3>Success rate</h3>
          <span>14 days · %</span>
        </header>
        <LineChart
          area
          colorKeys={['running']}
          labels={labels}
          series={[{ name: 'Success rate', data: successRate }]}
          height={180}
        />
      </section>
      <section className="chart-card">
        <header className="chart-card-heading">
          <h3>Cost</h3>
          <span>14 days · USD</span>
        </header>
        <BarChart
          colorKeys={['autonomous']}
          labels={labels}
          series={[{ name: 'Cost', data: cost }]}
          height={180}
        />
      </section>
    </div>
  );
}

export default PerformanceChart;
